import React, { FunctionComponent, useState } from 'react';
import { Flex, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from "@chakra-ui/react";
import { localisable } from "../../../generic/localisable";
import { RouteComponentProps, Router, navigate } from "@reach/router";
import { PrivateRoutes } from '../../PrivateRoutes/PrivateRoutes';
import { LoginPage } from '../pages/LoginPage';
import { ResetPassword } from '../pages/ResetPasswordPage';
import { PayRentPage } from '../pages/PaymentPage';
import { PaymentThankYouPage } from '../pages/PaymentThankYouPage';
import { AutoPayChangePage } from '../pages/AutoPayChangePage';
import { AutoPayPage } from '../pages/AutoPayPage';
import { TenantUpdatePage } from '../pages/TenantUpdatePage';
import { TenantUpdateSuccessPage } from '../pages/TenantUpdateSuccessPage';
import { ForgotPasswordEmailForm } from '../forgotPassword/ForgotPassword';
import { ForgotPasswordVerifyEmailPage } from '../pages/ForgotPasswordVerifyEmailPage';
import { ForgotPasswordVerifyCodePage } from '../pages/ForgotPasswordVerifyCodePage';
import { ForgotPasswordResetPasswordPage } from '../pages/ForgotPasswordResetPasswordPage';

interface IPayRentLayoutProps extends RouteComponentProps {
    isAutoPayTab: boolean,
    isUpdateTenantInfoTab: boolean
};

const navigateTo = (route: string) => {
    const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
    const pathSegments = currentPath.split('/');
    // Keep only the segments up to and including "pay-rent"
    const basePath = pathSegments.slice(0, pathSegments.indexOf('pay-rent') + 1).join('/');
    navigate(`${basePath}/${route}`);
}


export const PayRentLayout: FunctionComponent<IPayRentLayoutProps> = (
    {
        isAutoPayTab = true,
        isUpdateTenantInfoTab = true,
        uri
    }
) => {
    const [activeTab, setActiveTab] = useState('login')

    const onTabClick = (route: string) => {
        setActiveTab(route);
        navigateTo(route);
    };

    const isActive = (route: string) => activeTab === route ? 'brand.secondary' : 'brand.inactive';

    return (
        <Flex
            padding='16px'
            color='text.grey'
            my={'12px'}
            display={'flex'}
            justifyContent={'center'}
            minH={'80vh'}
        >
            <Tabs w={{ base: '100%', lg: '70%' }} maxW={'1092px'}>
                <TabList w='100%' h='fit-content' display='flex' mb={{ base: '16px', sm: '0px' }} borderRadius='2px' overflow='hidden'>
                    <Tab
                        flex='1'
                        bg={isActive('payment')}
                        _selected={{
                            bg: 'brand.secondary',
                            borderColor: 'tabsHeader.active',
                            flex: { base: 'none', sm: '1', md: '1' },
                        }}
                        onClick={() => onTabClick('payment')}
                    >
                        <Text noOfLines={1} textStyle='body1' color='text.grey'>{localisable.payRent}</Text>
                    </Tab>
                    {isAutoPayTab &&
                        <Tab
                            flex='1'
                            bg={isActive('auto-pay')}
                            _selected={{
                                bg: 'brand.secondary',
                                borderColor: 'tabsHeader.active',
                                flex: { base: 'none', sm: '1' },
                            }}
                            onClick={() => onTabClick('auto-pay')}
                        >

                            <Text noOfLines={1} textStyle='body1' color='text.grey'>{localisable.signUpForAutoPay}</Text>
                        </Tab>
                    }
                    {isUpdateTenantInfoTab &&
                        <Tab
                            flex='1'
                            bg={isActive('tenant-update')}
                            _selected={{
                                bg: 'brand.secondary',
                                borderColor: 'tabsHeader.active',
                                flex: { base: 'none', sm: '1' },
                            }}
                            borderRadius='2px'
                            border='1px solid'
                            borderColor='tabsHeader.inActive'
                            onClick={() => onTabClick('tenant-update')}
                        >
                            <Text noOfLines={1} textStyle='body1' color='text.grey'>{localisable.updateTenantInformation}</Text>
                        </Tab>
                    }
                </TabList>
                <TabPanels>
                    <Router basepath={uri} >
                        <LoginPage path={'login'} />
                        <PrivateRoutes path={'payment'} component={PayRentPage} />
                        <PrivateRoutes path={'thank-you'} component={PaymentThankYouPage} />
                        <PrivateRoutes path={'auto-pay'} component={AutoPayPage} />
                        <PrivateRoutes path={'auto-pay-change'} component={AutoPayChangePage} />
                        <PrivateRoutes path={'tenant-update'} component={TenantUpdatePage} />
                        <PrivateRoutes path={'update-tenant-success'} component={TenantUpdateSuccessPage} />
                        <ResetPassword path={'reset-password'} />
                        <ForgotPasswordVerifyEmailPage path={'forgot-password'} />
                        <ForgotPasswordVerifyCodePage path={'verify-code'} />
                        <ForgotPasswordResetPasswordPage path={'reset'} />
                        {/* <Component3 path={'update-tenant'} /> */}
                        {/* <PrivateRoutes path={'tenant-update'} component={<h1>Hello World</h1>} /> */}

                    </Router>
                </TabPanels>
            </Tabs>
        </Flex >
    )
}

const Component1: FunctionComponent<RouteComponentProps> = () => {
    return <h1>Pay Rent</h1>
}

const Component2: FunctionComponent<RouteComponentProps> = () => {
    return <h1>Auto Pay</h1>
}

const Component3: FunctionComponent<RouteComponentProps> = () => {
    return <h1>Tenant Update</h1>
}